import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const ReporteClientesNoReportado = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [ejercicio, setEjercicio] = useState("");
  const [periodo, setPeriodo] = useState("");
  var nombreperiodo;
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedClientIds, setSelectedClientIds] = useState([]);

  const onHome = () => {
    history.push("/Credito/Main");
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const getRowClass = (item) => {
    if (!item.registrado) {
      return "bg-red";
    } else if (!item.tiene_domicilio){
      return "bg-yellow";
    }
  
    // Verifica si el ID de cliente está en selectedRows o selectedClientIds
    if (selectedRows[item.idcliente] || selectedClientIds.includes(item.idcliente)) {
      return "selected";
    }
  
    return "";
  };

  useEffect(()=>{
    setLoader ({ ...loader, mostrar:true });
    request
    .get(`CargaReporteClientesNoReportados/CargarNoReportados`)
    .then((result) =>{
        setLoader ({ ...loader, mostrar: false});
        setData(result)
        console.log (result)
    })
    .catch((error) => {
        setLoader({ ...loader, mostrar: false });
    })
}, []);


  return (
    <PlantillaScreen
      titulo={`LISTADO DE CLIENTES NO REPORTADOS`}
      className_main={1}
      className={"reporte-clientes-noreportados"}
    >

      <LoaderScreen loader={loader} />
      <div className="reporte-buro-container">
        <div className="reporte-buro-tabla scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr className="reporte-buro-tabla-columnas">
                <th>ID CLIENTE</th>
                <th>RAZON SOCIAL</th>
                <th>RFC</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.idcliente} className={getRowClass(item)}>
                  <td>{item.idcliente}</td>
                  <td>{item.razon_social}</td>
                  <td>{item.rfc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="reporte-buro-footer">
        <div className="home-bc" onClick={onHome}>
          <ArrowBackIcon /> Regresar
        </div>
        </div>
    </PlantillaScreen>
  );
};

